import React from 'react';
import { Hue, Alpha } from 'react-color/lib/components/common';
import Pointer from './pointer';

/*
 * Hue and Alpha expect the pointer prop to be a component that only accepts
 * { direction?: "vertical" }, but Pointer expects a { hex: string } prop.
 * This is a known issue with @types/react-color and
 * cannot be fixed without ignoring the type check here.
 */

function ColorPattern(props) {
  const { hex, enableAlpha } = props;

  return (
    <div className="ws-ui-color-picker__color-pattern">
      <div className="ws-ui-color-picker__color-example" style={{ backgroundColor: hex }} />
      <div className="ws-ui-color-picker__sliders-wrapper">
        <div className="ws-ui-color-picker__slider">
          <Hue
            {...props}
            // eslint-disable-next-line yola/@typescript-eslint/ban-ts-comment
            /* @ts-ignore TS(2769): @types/react-color pointer typing is wrong */
            pointer={Pointer}
            direction="horizontal"
          />
        </div>
        {enableAlpha && (
          <div className="ws-ui-color-picker__slider">
            <Alpha
              {...props}
              // eslint-disable-next-line yola/@typescript-eslint/ban-ts-comment
              /* @ts-ignore TS(2769): @types/react-color pointer typing is wrong */
              pointer={Pointer}
              direction="horizontal"
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default ColorPattern;
